import { useCallback } from 'react';
import type { AutorizaceSluzbaAutorizaceDto } from '@gov-nx/api';
import {
	vypisSeznamSluzebProAutorizaci,
	useAxiosInstance,
	usePoQuery,
	useUnauthorizedResponse,
	isResponseStatus,
} from '@gov-nx/api';
import { useAppContext, useExtraConfigContext } from '@gov-nx/core/app';
import { useAutorizaceStore } from '@gov-nx/store';

const queryKey = ['seznam-sluzeb-app-portal-obcana'];

export const useServiceListLoader = () => {
	const { axiosInstance } = useAxiosInstance();
	const { isUnauthorizedResponse } = useUnauthorizedResponse();
	const { setAppError } = useAppContext();
	const {
		extraConfig: {
			authorization: { enabled: isAuthorizationEnabled },
		},
	} = useExtraConfigContext();
	const setServicesList = useAutorizaceStore('setServicesList');

	const initQuery = usePoQuery(
		{
			queryFn: async (): Promise<AutorizaceSluzbaAutorizaceDto[]> => {
				if (!isAuthorizationEnabled) {
					setServicesList([]);
					return [];
				}

				const data = await vypisSeznamSluzebProAutorizaci(axiosInstance);

				const list = data.data.seznam ?? [];
				setServicesList(list);

				return list;
			},
			onError: (error) => {
				if (!isUnauthorizedResponse(error)) {
					setAppError(error as Error);
				}
			},
			queryKey,
			enabled: false,
			retry: 0,
		},
		{
			errorIgnoreFilter: isResponseStatus(404),
		}
	);

	const fetch = useCallback(async () => {
		if (!isAuthorizationEnabled) {
			return;
		}

		await initQuery.refetch();
	}, [initQuery, isAuthorizationEnabled]);

	return { initServicesList: fetch };
};
